import { ExclamationCircleFilled, PauseOutlined } from "@ant-design/icons";
import { Col, Modal, Row } from "antd";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
// import { ItemsTableInterface } from "../../../Interfaces/ItemsTable";
import { useDispatch, useSelector } from "react-redux";
import { Sale, createSale } from "../../../../api/sales";
import { handleMakePayment } from "../../CheckoutNew";
import { mainActions } from "../../../../store/main/mainSlice";

// type PropsType = {
//   items: ItemsTableInterface[];
// };

const Hold = () => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const items = useSelector((state: any) => state.main.items);
  const customer = useSelector((state: any) => state.main.customer);
  const discount = useSelector((state: any) => state.main.discount);
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;

  const { mutateAsync: createSaleMutation } = useMutation(
    "createSale",
    (body: Sale) => createSale(body)
  );

  const dispatch = useDispatch();
  const sessionId = useRef(localStorage.getItem("sessionId"));
  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);
  const exchangeRate = useSelector((state: any) => state.main.exchangeRate);

  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;

  return (
    <>
      <PauseOutlined
        onClick={() => {
          items.length !== 0 && setOpen(true);
        }}
        style={
          items.length !== 0
            ? {
                fontSize: "24px",
                color: "#162149",
                cursor: "pointer",
              }
            : {
                fontSize: "24px",
                color: "#9e9e9e",
                cursor: "not-allowed",
              }
        }
      />

      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => setOpen(false)}
        open={open}
        centered
        title={
          <>
            <Row>
              <Col span={3}>
                <ExclamationCircleFilled
                  style={{
                    color: "#FFBC39",
                    fontSize: "45px",
                    marginRight: "12px",
                    marginTop: "22px",
                  }}
                />
              </Col>

              <Col span={19}>
                <Col
                  style={{
                    fontSize: "32px",
                    color: "#212121",
                  }}
                >
                  {" "}
                  {t("confirm-delete")}
                </Col>
                <Col
                  span={19}
                  style={{
                    fontSize: "16px",
                    color: "#212121",
                    wordWrap: "break-word",
                  }}
                >
                  {t("please-confirm-Holding")}
                </Col>
              </Col>
            </Row>
          </>
        }
        onOk={() => {
          handleMakePayment(
            true,
            formattedDate,
            items,
            createSaleMutation,
            customer,
            discount,
            mainCurrency,
            sessionId,
            invoiceNo,
            exchangeRate
          ).then((res) => {
            setOpen(false);
            dispatch(mainActions.clearInvoice());
          });
        }}
        okText={`${t("confirm")}`}
        cancelText={`${t("cancel")}`}
        okButtonProps={{ style: { height: "40px" } }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            marginInlineEnd: "auto",
            height: "40px",
          },
        }}
      />
    </>
  );
};

export default Hold;
